export enum PregnancyDurationType {
  WEEKS = 'WEEKS',
  DAYS = 'DAYS',
  MONTHS = 'MONTHS'
}

export interface VacationCalculation {
  employeeName: string
  employeeId: string
  city: string
  startDate: string
  birthType: 'single' | 'twins' | 'triplets' | 'quadruplets'
  hasExtendedDays: boolean
  rewardLeave: boolean
  firstChild?: 'yes' | 'no' // 是否生育一孩（绍兴特殊选项 - 用户输入）
  isFirstTimeBirth?: boolean // 是否为一孩（后端返回结果 - 用于绍兴）
  deliveryMethod: 'normal' | 'difficult' | 'miscarriage'
  pregnancyDuration?: number
  pregnancyDurationType?: PregnancyDurationType
  isMiscarriage?: boolean
  calculatedDays: number
  totalAllowanceDays?: number // 享受津贴天数（用于津贴计算）
  maternityLeaveStartDate?: string // API返回的实际产假开始日期
  maternityLeaveEndDate?: string // API返回的实际产假结束日期
}

export interface CustomInputItem {
  id: string
  label: string
  value: string
  isEditing?: boolean
}

export interface AllowanceForm {
  city: string
  governmentAmount?: string | undefined
  advanceInputMethod: 'detailed' | 'total' | 'itemized'
  advanceTotal?: string | undefined
  employeeInsurance?: string | undefined
  supplementaryFund?: string | undefined
  unionFee?: string | undefined
  espp?: string | undefined
  socialInsuranceBase?: string | undefined
  employerESPP?: string | undefined
  employerSupplementaryFund?: string | undefined
  personalIncomeTax?: string | undefined
  otherDeductions?: string | undefined
  flexibleBenefit?: string | undefined
  spotOn?: string | undefined
  customInputs?: CustomInputItem[] // 自定义输入项
  customDeductions?: CustomInputItem[] // 自定义减项
  paidSalary?: string | undefined
  declaredSalary?: string | undefined
  avgSalary12Months?: string | undefined
  crossJuly: boolean
  insuranceBefore?: string | undefined
  insuranceAfter?: string | undefined
  adjustedSocialInsuranceBase?: string | undefined
  crossApril: boolean
  monthlyBaseSalary?: string | undefined
  adjustedMonthlyBaseSalary?: string | undefined
  paidSalaryBeforeApril?: string | undefined
  paidSalaryAfterApril?: string | undefined
  isBankEmployee: boolean
  receivedTime?: string | undefined // 政府补贴发放时间（年-月-日格式）
  submissionTime?: string | undefined // 提交核定表时间（年-月-日格式）
  maternitySubmissionDate?: string | undefined // 产假提交时间（日期格式）
}

export interface CalculationResult {
  allowanceAmount: number
  governmentAmount: number
  paidSalary: number
  difference: number
  futureAdjustment: number
  breakdown: string[]
  recommendation: string
  employeeRefundAmount?: number
  totalAllowanceDays?: number
}

export interface City {
  value: string
  label: string
}

export interface HistoryRecord {
  id: string
  employeeName: string
  employeeId: string
  city: string
  cityName: string
  startDate: string
  endDate: string
  totalDays: number
  companyCompensation: number
  employeeCompensation: number
  calculatedAt: string
  recordType: 'allowance' | 'maternity'
  vacationData: VacationCalculation
  allowanceData: { [key: string]: unknown }
  receivedTime?: string // 提交核定表时间（年-月-日格式）
  submissionTime?: string // 提交产假时间（年-月-日格式）
}
